import { render } from "./selectMovie.vue?vue&type=template&id=dd2429f2&scoped=true"
import script from "./selectMovie.vue?vue&type=script&lang=js"
export * from "./selectMovie.vue?vue&type=script&lang=js"

import "./selectMovie.vue?vue&type=style&index=0&id=dd2429f2&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2429f2"]])

export default __exports__